/**
 * Helper for messing with columns attributes from outside of this package.
 *
 * @param {Object} attributes    The block attributes object.
 * @param {number} columns       Number of columns to set.
 * @param {number} mobileColumns Number of mobile columns to set.
 * @return {Object} The modified attributes object.
 */
export const setupColumns = ( attributes, columns, mobileColumns ) => {
	// Let's not mutate the original attributes object.
	const copyAttributes = { ...attributes };
	copyAttributes.columns = columns;
	copyAttributes.mobileColumns = mobileColumns;
	return copyAttributes;
};

/**
 * Reset columns to default values from attributes.
 *
 * @param {Function} setColumns       The setColumns state function.
 * @param {Function} setMobileColumns The setMobileColumns state function.
 * @param {Object}   attributes       The block attributes object.
 */
export const resetColumns = ( setColumns, setMobileColumns, attributes ) => {
	if ( document.startViewTransition ) {
		document.startViewTransition( () => {
			setColumns( attributes.columns || 4 );
			setMobileColumns( attributes.mobileColumns || 2 );
		} );
	} else {
		setColumns( attributes.columns || 4 );
		setMobileColumns( attributes.mobileColumns || 2 );
	}
};

/**
 * Set columns to alternative view values from attributes.
 *
 * @param {Function} setColumns       The setColumns state function.
 * @param {Function} setMobileColumns The setMobileColumns state function.
 * @param {Object}   attributes       The block attributes object.
 */
export const setAltViewColumns = ( setColumns, setMobileColumns, attributes ) => {
	if ( document.startViewTransition ) {
		document.startViewTransition( () => {
			setColumns( attributes?.altViewColumns || 2 );
			setMobileColumns( attributes?.altViewMobileColumns || 1 );
		} );
	} else {
		setColumns( attributes?.altViewColumns || 2 );
		setMobileColumns( attributes?.altViewMobileColumns || 1 );
	}
};
